import { HttpClient } from '@angular/common/http';
import {
  Component,
  Input,
  OnInit,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { LanguageService } from 'vhobjects-service/src/services';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { AtwMenuHorizontalAdmin } from '../../../menu-horizontal/admin/menu-horizontal-admin/menu-horizontal-admin.component';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';
import { MatDialog } from '@angular/material/dialog';
import { ColorContrastComponent } from '../../../../../color-contrast/color-contrast.component';


@Component({
  selector: 'atw-menu-horizontal-admin-config',
  templateUrl: './menu-horizontal-admin-config.component.html',
  styleUrls: ['./menu-horizontal-admin-config.component.scss']
})
export class AtwMenuHorizontalAdminConfig extends AtwUpdateDbComponent implements OnInit {
 @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  selectedValuePosition = "before";
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  styles_field = [
    {
      title: 'Hiệu ứng khi chọn',
      index: 1,
    },
    {
      title: 'Hiệu ứng khi chạm',
      index: 2,
    },
    {
      title: 'Cấu hình chi tiết hiệu ứng menu',
      index: 3,
    },
    {
      title: 'Cấu hình chi tiết hiệu ứng menu con',
      index: 4,
    },
    {
      title: 'cau_hinh_mau_gradient_menu',
      index: 5,
    },
    {
      title: 'cau_hinh_mau_gradient_menu_con',
      index: 6,
    },
    {
      title: 'cau_hinh_mau_gradient_khi_chon_menu',
      index: 7,
    },
    {
      title: 'cau_hinh_mau_gradient_khi_chon_menu_con',
      index: 8,
    },
  ];
  fieldConfigGradient = {
    5: 'menu_background-color',
    6: 'submenu_background-color',
    7: 'active_menu_background-color',
    8: 'active_submenu_background-color'
  };

  dataAfterChange: any = {}; // lưu tên và style data để cập nhật vào database.
  valueRange: number = 0; // biến này tính giá trị của (input range / 100) để tính độ trong suốt
  valueParameter: number = 0; // biến này tính giá trị của (input range) để hiện thị giá trị ra màn hình
  isOpenBackground: boolean = false; // biến này dùng để mở bảng màu
  fieldSettingEffect: string = '';
  isOpenOptionsBorder: boolean = false; // biến này dùng để mở bảng lựa chọn viền của menu
  isOpenOptionsSubBorder: boolean = false; // biến này dùng để mở bảng lựa chọn viền của sub-menu
  isOpenOptionsBorderSymbol: boolean = false; // biến này dùng để mở bảng lựa chọn viền của biểu tượng
  style_color: string = ''; // biến này lấy giá trị của màu rgb và alpha;
  arr_link_page: any;
  isConfigSubMenu: boolean = false; // biến này dùng để mở cấu hình sub-menu
  optionsIcon = [
    {
      value: 'keyboard_arrow_down',
      label: 'keyboard_arrow_down',
      icon: 'keyboard_arrow_down',
    },
    {
      value: 'keyboard_arrow_right',
      label: 'keyboard_arrow_right',
      icon: 'keyboard_arrow_right',
    },
    {
      value: 'arrow_drop_down',
      label: 'arrow_drop_down',
      icon: 'arrow_drop_down',
    },
    { value: 'arrow_right', label: 'arrow_right', icon: 'arrow_right' },
    { value: 'chevron_right', label: 'chevron_right', icon: 'chevron_right' },
    { value: 'expand_more', label: 'expand_more', icon: 'expand_more' },
  ];
  fonts = [];
  backgroundColor: any = [];
  dataBorder = [
    {
      name: 'solid',
      img_border: 'https://static.thenounproject.com/png/2264019-200.png',
    },
    {
      name: 'dashed',
      img_border: 'https://static.thenounproject.com/png/2264023-200.png',
    },
    {
      name: 'dotted',
      img_border: 'https://static.thenounproject.com/png/2449182-200.png',
    },
  ];

  /**
   * Biến này để hiển thị cấu hình menu cấp n của menu khi ở dạng điện thoại
   */
  subMobileArray: any = []; 

  // Mảng danh sách group (link/category/pop-up) kiểu menu
  listGroupLink = [
    {
      value: 'link',
      label: 'duong_dan',
      checked: false,
    },
    {
      value: 'category',
      label: 'goi_danh_muc',
      checked: false,
    },
    {
      value: 'pop-up',
      label: 'goi_hop_thoai',
      checked: false,
    },
  ];

  effect_hover = [];
  effect_hover_data: any = {};
  customize = [];
  isNeedToUpdate: boolean = false; // biến này cho biết có cần cập nhật object hay không ở ngOnInit khi kiểm tra class menu có trong database hay chưa
  data_class: any = {}; // biến này lưu dữ liệu class menu
  configMode: 'basic' | 'advanced' = 'basic';
  positionChildMenus = [
    {label: 'menu_con_hien_thi_ngang_voi_menu_cha', value: 'horizontal'},
    {label: 'menu_con_hien_thi_tren_cung', value: 'top'}
  ]
  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    public vhEventMediator: VhEventMediator,
    private renderer: Renderer2,
    public languageService: LanguageService,
    private nzModalService: NzModalService,
    @Inject(PLATFORM_ID) private platformId: Object,
    public functionService: FunctionService,
    private matDialog: MatDialog,
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
   }

  ngOnInit(): void {
    this.class = this.objectChoosing[this.device + '_class'];
    this.subMobileArray = [];
    // Cập nhật danh sách kiểu của menu
    this.listGroupLink = this.listGroupLink.map((item) => ({
      ...item,
      label: this.languageService.translate(item.label),

      checked:
        !this.objectChoosing['groups'] ||
        this.objectChoosing['groups'].includes(item.value),
    }));

    forkJoin([
      this.http.get('assets/background-colors/background-colors.json'),
      this.http.get('assets/fonts/fonts.json'),
      this.http.get('assets/data/effects/menu-horizontal.json'),
      this.http.get('assets/data/type_menu_horizontal/type_class.json'),
    ]).subscribe(([background_colors, fonts, effects, data_class]: any) => {
      this.fonts = fonts;
      this.backgroundColor = background_colors;
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(
        (e) => e.type == this.staticdata[this.device + '_animation_type']
      );
      this.data_class = data_class;
    });

    
    if(!this.config['scrollbar']) {
      this.config['scrollbar'] = {};
    }

    this.subMobileArray = []; // reset mảng chứa submenu
    if (this.config['type'] == 'vertical') {
      const level = this.getMaxLevel(this.staticdata.menu_data);
      for (var i = 0; i < level; i++) {
        // kiểm tra xem class menu có trong db không? 
        // không được xóa đoạn || !this.class[`mobilemenu__list--item${i}`] vì khi thêm cấp mới cho menu sẽ lỗi cấp mới k có class mặc định
        if (!this.class.hasOwnProperty(`mobilemenu__list--item${i}`) || !this.class[`mobilemenu__list--item${i}`]) {
          // chưa có thì add style mặc định vô
          this.class[`mobilemenu__list--item${i}`] = {
            'padding-left': (i + 1) * 10 + 'px',
            'background-color': '#ffffff',
            display: 'flex',
            'justify-content': 'flex-start',
            'align-items': 'center',
            height: '32px',
            'font-size': '14px',
            'text-align': 'left',
            'font-family': 'Arial',
            'font-weight': '400',
            'font-style': 'normal',
            'text-decoration': 'none',
            'text-transform': 'none',
            'letter-spacing': '0px',
            'border-left-width': '0',
            'border-top-width': '0',
            'border-right-width': '0',
            'border-bottom-width': '0',
            'border-style': 'solid',
            'border-color': '#000000',
            'border-radius': '0px',
            'margin-bottom': '0px',
            cursor: 'pointer',
          };
          this.isNeedToUpdate = true;
        }
        this.subMobileArray.push(`mobilemenu__list--item${i}`);
      }
      if (this.isNeedToUpdate) {
        this.updateClass();
        this.isNeedToUpdate = false;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(!this.config.hasOwnProperty('mobile-box-shadow')) {
      this.config['mobile-box-shadow'] = {
        "property_box_shadow": {
          "blur": 1,
          "v-offset": 1,
          "h-offset": 1,
          "type": "outset",
          "color": "#ffffffff",
          "spread": 1
        },
        "is_box_shadow": false
      };
    }
    if(!this.config.hasOwnProperty('submenu_box-shadow-wrapper')) {
      this.config['submenu_box-shadow-wrapper'] = {
        "property_box_shadow": {
          "blur": 1,
          "v-offset": 1,
          "h-offset": 1,
          "type": "outset",
          "color": "#ffffffff",
          "spread": 1
        },
        "is_box_shadow": false
      };
    }
    // Xoá đi dữ liệu cũ
    if (this.config["menu_background-color"].hasOwnProperty('check_gradient')) 
      delete this.config["menu_background-color"];
    if (this.config["submenu_background-color"].hasOwnProperty('check_gradient')) 
      delete this.config["submenu_background-color"];

    // Update dữ liệu mới
    const gradientObj = {
      "background": "#8c52ff",
      "gradient_direction": "",
      "value_range": 1,
      "gradient_type": "linear-gradient",
      "gradient_arr": [
        "rgb(0, 0, 255)",
        "rgb(255, 255, 0)"
      ],
      "value_parameter": 100,
      "gradient_check": false
    };
    this.config["menu_background-color"] ??= gradientObj;
    this.config["active_menu_background-color"] ??= gradientObj;
    this.config["submenu_background-color"] ??= gradientObj;
    this.config["active_submenu_background-color"] ??= gradientObj;
    if (!this.config.hasOwnProperty('position_childmenu')) {
      this.config.position_childmenu = 'top';
    }
    if (!this.config.hasOwnProperty('is_on_active_menu_mobile')) {
      this.config.is_on_active_menu_mobile = false;
    }
    if (!this.class['mobilemenu__item--content-left']?.hasOwnProperty('color') && this.config.type == 'vertical') {
      this.class['mobilemenu__item--content-left'].color = 'inherit';
    }
    if (!this.config?.desktop_background_active_menu_item?.border_top_width) {
      this.config.desktop_background_active_menu_item.border_top_width = this.config.desktop_background_active_menu_item.border_width;
    }
    if (!this.config?.desktop_background_active_menu_item?.border_bottom_width) {
      this.config.desktop_background_active_menu_item.border_bottom_width = this.config.desktop_background_active_menu_item.border_width;
    }
    if (!this.config?.desktop_background_active_menu_item?.border_left_width) {
      this.config.desktop_background_active_menu_item.border_left_width = this.config.desktop_background_active_menu_item.border_width;
    }
    if (!this.config?.desktop_background_active_menu_item?.border_right_width) {
      this.config.desktop_background_active_menu_item.border_right_width = this.config.desktop_background_active_menu_item.border_width;
    }
    if (!this.config?.desktop_background_active_menu_item_sub?.border_top_width) {
      this.config.desktop_background_active_menu_item_sub.border_top_width = this.config.desktop_background_active_menu_item_sub.border_width;
    }
    if (!this.config?.desktop_background_active_menu_item_sub?.border_bottom_width) {
      this.config.desktop_background_active_menu_item_sub.border_bottom_width = this.config.desktop_background_active_menu_item_sub.border_width;
    }
    if (!this.config?.desktop_background_active_menu_item_sub?.border_left_width) {
      this.config.desktop_background_active_menu_item_sub.border_left_width = this.config.desktop_background_active_menu_item_sub.border_width;
    }
    if (!this.config?.desktop_background_active_menu_item_sub?.border_right_width) {
      this.config.desktop_background_active_menu_item_sub.border_right_width = this.config.desktop_background_active_menu_item_sub.border_width;
    }
    if (!this.config.accessibility) {
      this.config.accessibility = { enabled: false, nav_aria_label_vi: "Menu điều hướng chính" };
    }
    if (this.effect_hover) {
      if ([3, 4].includes(this.currentViewAll.index)) {
        const effectSub = this.currentViewAll.index == 3 ? '' : '_sub';
        this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[`${this.device}_animation${effectSub}_type`])
        if (this.config[`animation${effectSub}-selected`]?.id && this.config[`animation${effectSub}-selected`].id !== '000000') {
          this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config[`animation${effectSub}-selected`].id)?.[`customize${effectSub}`] ?? [];
        }
      }
    }
  }


  /**
   * Xử lý sự kiện Bật/Tắt thanh cuộn cho menu con khi config['type'] == 'horizontal'
   */
  updateScrollbar(event: any) {
    if(event) {
      this.class['submenu']['overflow'] = 'visible';
      this.class['submenu__container']['overflow-y'] = 'auto';
    }
    else {
      this.class['submenu']['overflow'] = '';
      this.class['submenu__container']['overflow-y'] = '';
    }
    this.updateClass();
    this.updateConfig();
  }


  /**
   * Xử lý sự kiện Bật/Tắt thanh cuộn cho menu con kh config['type'] == 'vertical'
   */
  updateScrollbarMobile(event: any) {
    if(event) {
      this.class['mobilemenu__list']['overflow-y'] = 'auto';
    }
    else {
      this.class['mobilemenu__list']['overflow-y'] = '';
    }
    this.updateClass();
    this.updateConfig();
  }


  /**
   * Bắt sự kiện chọn kiểu của menu
   *
   * @param value - Mảng các object đại diện cho kiểu được chọn. Mỗi object có trường `checked` đại diện cho kiểu đó có được chọn hay không và trường `value` đại diện cho tên của kiểu.
   */
  handleSelectGroups(value: { checked: boolean; value: any }[]): void {
    // cập nhật danh sách kiểu được chọn (chỉ nhận nếu có checked === true)
    this.objectChoosing['groups'] = value
      .filter((item) => item.checked)
      .map((item) => item.value);
    this.updateGroups();
  }

  /**
   * Handle remove menu trên mobile-menu
   * @param tree: Biến dùng để lưu data menu
   * @param currentLevel: Hàm trả về level cao nhất của cây
   *
   */
  getMaxLevel(tree, currentLevel = 1) {
    if (!tree || !tree.length) return currentLevel;

    let maxLevel = currentLevel;

    for (let node of tree) {
      if (node.children && node.children.length > 0) {
        const level = this.getMaxLevel(node.children, currentLevel + 1);
        if (level > maxLevel) {
          maxLevel = level;
        }
      }
    }

    return maxLevel;
  }

  /**
   * Hàm này dùng để dịch chuyển mobilemenu con về bên phải trên mobile khi click về menu cha
   * @param menuId:cấp của menu con.
   */
  addAttrClass(menuId: number) {
    if (menuId !== 0) {
      this.class[`mobilemenu__list--item${menuId}`]['padding-left'] =
        (menuId + 1) * 10 + 'px';
    }
  }


  /**
   * Hiển thị sub-menu để dễ config
   */
  isShowSub:boolean = false;
  showSubMenu() {
    if (this.config['type'] == 'horizontal' && !this.isShowSub) {
      this.isShowSub = true;
      this.vhEventMediator.notifyOnConfigChanged({
        id: this.objectChoosing._id,
        showSub: true,
      });
    }
  }

  hideSubMenu() {
    if (this.config['type'] == 'horizontal') {
      this.isShowSub = false;
      this.vhEventMediator.notifyOnConfigChanged({
        id: this.objectChoosing._id,
        showSub: false,
      });
    }
  }

  /**
   * Handle remove menu trên mobile-menu
   * @param menuId: hàm này dùng để update css menu con
   */
  updateCssMobileMenu(menuId?: number) {
    if (isPlatformBrowser(this.platformId)) {
      // Update các menu con chỉ định
      // lấy menu con de css
      if (menuId !== 0) {
        let elementArray = document.querySelectorAll(
          `[id="${this.objectChoosing._id}"] .mobilemenu__list--item${menuId}`
        );

        if (elementArray && elementArray.length > 0) {
          // update tất cả css cho các menu con cùng cấp
          elementArray.forEach((div) => {
            div.setAttribute(
              'style',
              this.getStyleString(this.class[`mobilemenu__list--item${menuId}`])
            );
          });
        }
      }

      // Update các css trong phần Biểu tượng menu con cho tất cả menu con
      if (!this.config['icon_menu']['show_icon_sub']) {
        // Biểu tượng menu con bị ẩn
        document
          .querySelectorAll(
            `[id="${this.objectChoosing._id}"] .mobilemenu__item--icon`
          )
          .forEach((element) => {
            element.setAttribute('style', 'display: none');
          });
      } else {
        // Biểu tượng menu con hiển thị
        document
          .querySelectorAll(
            `[id="${this.objectChoosing._id}"] .mobilemenu__item--icon`
          )
          .forEach((element) => {
            this.class['mobilemenu__item--icon']['display'] = 'flex';
            element.setAttribute(
              'style',
              this.getStyleString(this.class['mobilemenu__item--icon'])
            );
            element.innerHTML = this.config['icon_menu']['name_icon'];
            // element.setAttribute('style', 'display: flex');
          });
      }
    }
  }

  /**
   * Hàm chuyển đổi style từ object thành chuỗi
   */
  getStyleString(styleObj: any): string {
    return Object.keys(styleObj)
      .map((key) => `${key}: ${styleObj[key]}`)
      .join(';');
  }

  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');

    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }
  /**
   * Xử lý lấy thông số giá trị background color.
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundColor(e, type, id?: number) {
    // lấy giá trị tham số event của thanh slide khi thay đổi.
    this.valueParameter = e.target.value;
    // Tính giá trị alpha cho màu rgb.
    const data =
      this.device == 'desktop'
        ? this.class[`${type}__item`]
        : this.class[`${type}__list--item${id}`];
    const lastCommaIndex = data['background-color'].lastIndexOf(',');
    const prefix = data['background-color'].substring(0, lastCommaIndex + 1);
    this.style_color = `${prefix} ${this.valueParameter / 100})`;

    data['background-color'] = this.style_color;
    this.updateObject();
  }
  /**
   * Hàm này lấy giá trị màu nền của input color
   * @param event : trả về màu được chọn từ input color
   */
  updateColorInput(e, type, mobileid?: number) {
    const value_color = e.target.value;
    const data_desktop = this.class[`${type}__item`];
    const data_mobile = this.class[`${type}__list--item${mobileid}`];
    // Chuyển đổi chuổi màu hexadecimal thành rgb
    // Nối chuỗi rgb + giá trị alpha và cập nhật lưu vào database.
    if (this.device == 'desktop') {
      this.style_color = `rgba(${this.hexToRGB(value_color)}, ${this.config[`${type}_background-color`]['value_range']
        })`;
      data_desktop.background = this.style_color;
      this.updateObject();
    } else {
      this.style_color = `rgba(${this.hexToRGB(value_color)}, ${this.config[`background-color`]['value_range']
        })`;
      data_mobile.background = this.style_color;
      this.updateObject();
    }
  }
  /**
   * Hàm này dùng để click chọn màu nền của danh sách màu.
   * @param bgColor : trả về màu được chọn
   * @param event : trả về element được active
   */
  chooseBg(bgColor, event, type, mobileid?: number | null) {
    if (isPlatformBrowser(this.platformId)) {
      // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
      // Lấy ra element màu được click từ tham số event trả về.
      var activeGradient = document.querySelector(
        '.container-color .active'
      ) as HTMLElement;
      var menuMobile = document.querySelectorAll(
        `.${type}__list--item${mobileid}`
      );
      if (activeGradient) activeGradient.classList.remove('active');
      event.currentTarget.classList.add('active');
      let data =
        this.config['type'] == 'horizontal'
          ? this.class[`${type}__item`]
          : this.class[`${type}__list--item${mobileid}`];
      // Lấy giá trị màu được click từ tham số bgColor.
      //  Chuyển đổi màu được click thành mã rgb , thêm alpha vào mã rgb và lưu vào database.
      data['background-color'] = `rgba(${this.hexToRGB(bgColor.bgColor)}, ${this.config['type'] == 'horizontal'
        ? this.config[`${type}_background-color`].value_range
        : this.config[`background-color`].value_range
        })`;
      menuMobile.forEach((element) => {
        this.renderer.setStyle(
          element,
          'background-color',
          `${data['background-color']}`
        );
      });
      this.updateObject();
    }
  }

  /**
   * Hàm update object vào database.
   */
  // updateObject() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, {
  //       [this.device + '_class']: this.class,
  //       [this.device + '_config']: this.config,
  //       staticdata: this.staticdata,
  //     })
  //     .then((bool: any) => {
        
  //     });
  // }

  /**
   * Hàm update class vào database.
   */
  // updateClass() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, {
  //       [this.device + '_class']: this.class,
  //     })
  //     .then((bool: any) => {
        
  //     });
  // }

  /**
   * Hàm update config vào database.
   */
  // updateConfig() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, {
  //       [this.device + '_config']: this.config,
  //     })
  //     .then((bool: any) => {
        
  //     });
  // }

  /**
   * Update trường groups cho object
   */
  // updateGroups() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, {
  //       groups: this.objectChoosing['groups'],
  //     })
  //     .then(
  //       (bool) => {
          
  //       },
  //       (error) => {
  //         console.error(error);
  //       }
  //     );
  // }

  /**
   * Cập nhật staticdata vào database.
   */
  // updateStaticData() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
  //     .then((bool) => {
        
  //     });
  // }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
    menu10: false,
    menu11: false,
    menu12: false,
    menu13: false,
  };

  /**
   * Hàm set vị trí của Khối hộp thoại khi hover
   * Chia làm 3 nhóm để xử lý:
   * Nhóm 1: center_screen (nhóm này set vị trí dựa trên toàn màn hình)
   * Nhóm 2: right_menu_grand, left_menu_grand, center_menu_grand (nhóm này set vị trí dựa trên menu cha)
   * Nhóm 3: right_menu_parent, left_menu_parent, center_menu_parent (nhóm này set vị trí dựa trên menu con đang được hover => cần tìm vị trí của menu mỗi khi hover => không cố định)
   */
  handleSetPopupPosition() {
    switch (this.config['popup_position']) {
      case 'center_screen':
       
        break;
      case 'right_menu_grand':
        this.class['popupmenu-wrapper']['position'] = 'absolute';
        this.class['popupmenu-wrapper']['right'] = '0';
        this.class['popupmenu-wrapper']['left'] = 'auto';
        this.class['popupmenu-wrapper']['transform'] = 'none';
        break;
      case 'left_menu_grand':
        this.class['popupmenu-wrapper']['position'] = 'absolute';
        this.class['popupmenu-wrapper']['right'] = 'auto';
        this.class['popupmenu-wrapper']['left'] = '0';
        this.class['popupmenu-wrapper']['transform'] = 'none';
        break;
      case 'center_menu_grand':
        this.class['popupmenu-wrapper']['position'] = 'absolute';
        this.class['popupmenu-wrapper']['right'] = 'auto';
        this.class['popupmenu-wrapper']['left'] = '50%';
        this.class['popupmenu-wrapper']['transform'] = 'translateX(-50%)';
        break;
      case 'left_menu_parent':
      case 'right_menu_parent':
      case 'center_menu_parent':
        this.class['popupmenu-wrapper']['position'] = 'fixed';
        this.class['popupmenu-wrapper']['right'] = 'auto';
        this.class['popupmenu-wrapper']['left'] = 'auto';
        this.class['popupmenu-wrapper']['transform'] = 'none';
        break;
      default:
        break;
    }
  }

  handleSetPositionIcon(value){
    this.selectedValuePosition = value;
    if(this.selectedValuePosition == "before"){
      this.class['menu__item--icon-before']['order'] = 1;
      this.class['menu__item--content-left']['order'] = 2;
    }
    else if(this.selectedValuePosition == "after"){
      this.class['menu__item--icon-before']['order'] = 2;
      this.class['menu__item--content-left']['order'] = 1;
    }
    this.updateObject();
    this.updateClass();
  }

  /**
   * Set kích thước cho icon sau
   * @param type : menu hay submenu
   */
  handleSetIconAfterPosition(type) {
    switch (this.class[type + '__item--content']['justify-content']) {
      case 'center':
        this.class[type + '__item--content-left']['width'] = 'fit-content';
        break;
      case 'space-between':
        this.class[type + '__item--content-left']['width'] = '100%';
        break;
      default:
        break;
    }
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    var effect =
      this.objectChoosing[this.device + '_config']['animation-selected'];
    if (effect.id == '000001') {
      this.class['submenu']['opacity'] = '';
      this.class['submenu']['visibility'] = '';
      this.updateClass();
    }

    this.customize = event;
    this.openViewAll(this.styles_field[2]);
  }

  /**
  * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
  * @param event customize sau khi thay đổi
  */
  openAnimationDetailChild(event) {

    var effect =
      this.objectChoosing[this.device + '_config']['animation_sub-selected'];
    if (effect.id == '000001') {
      this.class['submenu']['opacity'] = '';
      this.class['submenu']['visibility'] = '';
      this.updateClass();
    }

    this.customize = event;
    this.openViewAll(this.styles_field[3]);
  }

  /**
   *  Hàm này để xử lý hiệu ứng khi xuất hiện
   */
  openAnimationAppear(type) {
    switch (type) {
      case 'submenu': {
        this.customize = [
          {
            label: 'vi_tri_bat_dau',
            var: '--0h1f-transform',
            type: 'transform',
          },
          {
            label: 'vi_tri_ket_thuc',
            var: '--0h1t-transform',
            type: 'transform',
          },
          {
            label: 'do_trong_suot_bat_dau',
            var: '--0h1f-opacity',
            type: 'opacity',
          },
          {
            label: 'do_trong_suot_ket_thuc',
            var: '--0h1t-opacity',
            type: 'opacity',
          },
          {
            label: '',
            var: '--0h1-animation',
            type: 'animation',
          },
        ];
        break;
      }
      case 'block_hover_blank': {
        this.customize = [
          {
            label: 'vi_tri_bat_dau',
            var: '--0h3f-transform',
            translateX: "0",
            translateY: "0",
            type: 'transform',
          },
          {
            label: 'vi_tri_ket_thuc',
            var: '--0h3t-transform',
            translateX: "0",
            translateY: "0",
            type: 'transform',
          },
          {
            label: 'do_trong_suot_bat_dau',
            var: '--0h3f-opacity',
            type: 'opacity',
            value: "0"
          },
          {
            label: 'do_trong_suot_ket_thuc',
            var: '--0h3t-opacity',
            type: 'opacity',
            value: "1"
          },
          {
            label: '',
            var: '--0h3-animation',
            type: 'animation',
            "animation_name": "menu-horizontal-animate-0h3",
            "duration": "0s",
            "timing_function": "linear",
            "delay": "1",
            "iteration_count": "",
            "direction": "",
            "fill_mode": ""
          },
        ];
        break;
      }
      case 'mobilemenu': {
        this.customize = [
          {
            label: '',
            var: '--11-transform-origin-x-shared',
            type: 'transform-origin-x',
          },
          {
            label: '',
            var: '--11-transform-origin-y-shared',
            type: 'transform-origin-y',
          },
          {
            label: 'vi_tri_bat_dau',
            var: '--11f-transform',
            type: 'transform',
          },
          {
            label: 'vi_tri_ket_thuc',
            var: '--11t-transform',
            type: 'transform',
          },
          {
            label: 'do_trong_suot_bat_dau',
            var: '--11f-opacity',
            type: 'opacity',
          },
          {
            label: 'do_trong_suot_ket_thuc',
            var: '--11t-opacity',
            type: 'opacity',
          },
          {
            label: 'lop_bat_dau',
            var: '--11f-z-index',
            type: 'z-index',
          },
          {
            label: 'lop_ket_thuc',
            var: '--11t-z-index',
            type: 'z-index',
          },
          {
            label: 'thoi_gian_mot_chu_ky_hoat_canh_se_chay',
            var: '--11-animation-duration-shared',
            type: 'animation-duration',
          },
          {
            label: 'kieu_chay_hieu_ung',
            var: '--11-animation-timing-function-shared',
            type: 'animation-timing-function',
          }
        ];
        break;
      }
    }
  }
  handleChangeTypeMenu(event) {
    this.class = this.data_class[event];
    // set lại scrollbar
    this.config['scrollbar']['is_show_scrollbar'] = false;

    if (event == 'vertical') {
      this.subMobileArray = []; // reset mảng chứa submenu
      const level = this.getMaxLevel(this.staticdata.menu_data);
      for (var i = 0; i < level; i++) {
        // kiểm tra xem class menu có trong db không?
        if (!(`mobilemenu__list--item${i}` in this.class)) {
          // chưa có thì add style mặc định vô
          this.class[`mobilemenu__list--item${i}`] = {
            'padding-left': (i + 1) * 10 + 'px',
            'background-color': '#ffffff',
            'display': 'flex',
            'justify-content': 'flex-start',
            'align-items': 'center',
            'height': '32px',
            'font-size': '14px',
            'text-align': 'left',
            'font-family': 'Arial',
            'font-weight': '400',
            'font-style': 'normal',
            'text-decoration': 'none',
            'text-transform': 'none',
            'letter-spacing': '0px',
            'border-left-width': '0',
            'border-top-width': '0',
            'border-right-width': '0',
            'border-bottom-width': '0',
            'border-style': 'solid',
            'border-color': '#000000',
            'border-radius': '0px',
            'margin-bottom': '0px',
            'cursor': 'pointer',
          };
        }
        this.subMobileArray.push(`mobilemenu__list--item${i}`);
      }
      if(!this.config['position']) this.config['position']='absolute';
      this.class['mobilemenu__list']['position']==this.config['position']
      this.updateObject();
    } else {
      this.updateObject();
    }
  }

  handleChangePosition(event){
    this.class['mobilemenu__list']['position']=event
    if (this.config['type'] == 'vertical' && this.config['position'] == 'relative' && this.class['mobilemenu']['height']!='unset'){
      this.class['mobilemenu__toggle']['height']= this.class['mobilemenu']['height']
      this.class['mobilemenu']['height']= 'unset'
    }
    if (this.config['type'] == 'vertical' && this.config['position'] == 'absolute'){
      this.class['mobilemenu__list']['max-height'] = "100vh";
      this.class['mobilemenu__list']['overflow-y'] = 'auto';
      this.class['mobilemenu__list']['margin-top'] = '10px';
    } else {
      this.class['mobilemenu__list']['margin-top'] = '0px';
      if (this.class['mobilemenu__list']['max-height'])
        delete this.class['mobilemenu__list']['max-height'];
      if (this.class['mobilemenu__list']['overflow-y'])
        delete this.class['mobilemenu__list']['overflow-y'];
    }
    this.updateObject();
  }

  
  openModalEdit() {
    const modal: NzModalRef = this.nzModalService.create({
      nzTitle: this.languageService.translate('chinh_sua_noi_dung'),
      nzWidth: '80%',
      nzContent: AtwMenuHorizontalAdmin,
      nzComponentParams: {
        data: this.objectChoosing,
        type: 'admin'
      },
      nzFooter: null,
    });
    modal.afterClose.subscribe(result => {
      this.subMobileArray = []; // reset mảng chứa submenu
      if (this.config['type'] == 'vertical') {
        const level = this.getMaxLevel(this.staticdata.menu_data);
        for (var i = 0; i < level; i++) {
          // kiểm tra xem class menu có trong db không? 
          // không được xóa đoạn || !this.class[`mobilemenu__list--item${i}`] vì khi thêm cấp mới cho menu sẽ lỗi cấp mới k có class mặc định
          if (!this.class.hasOwnProperty(`mobilemenu__list--item${i}`) || !this.class[`mobilemenu__list--item${i}`]) {
            // chưa có thì add style mặc định vô
            this.class[`mobilemenu__list--item${i}`] = {
              'padding-left': (i + 1) * 10 + 'px',
              'background-color': '#ffffff',
              display: 'flex',
              'justify-content': 'flex-start',
              'align-items': 'center',
              height: '32px',
              'font-size': '14px',
              'text-align': 'left',
              'font-family': 'Arial',
              'font-weight': '400',
              'font-style': 'normal',
              'text-decoration': 'none',
              'text-transform': 'none',
              'letter-spacing': '0px',
              'border-left-width': '0',
              'border-top-width': '0',
              'border-right-width': '0',
              'border-bottom-width': '0',
              'border-style': 'solid',
              'border-color': '#000000',
              'border-radius': '0px',
              'margin-bottom': '0px',
              cursor: 'pointer',
            };
            this.isNeedToUpdate = true;
          }
          this.subMobileArray.push(`mobilemenu__list--item${i}`);
        }
        if (this.isNeedToUpdate) {
          this.updateClass();
          this.isNeedToUpdate = false;
        }
      }
    });
  }

  /**
   * Cập nhật số dòng
   */
  updateLineNumber(menu) {
    // Cập nhật các thuộc tính cần thiết cho thuộc tính -webkit-line-clamp hoạt động 
    this.class[menu]['-webkit-box-orient'] ??= 'vertical';
    if (this.class[menu]['display'] != '-webkit-box') this.class[menu]['display'] = '-webkit-box';
    this.updateClass(); 
  }

  /**
   * Mở popup so sánh màu nền và màu chữ có tương phản hay không
   * (Để tối ưu Accessibility trong SEO)
   */
  openColorContrast(type: 'menu' | 'menu_con' | 'khi_chon_menu' | 'khi_chon_menu_con') {
    let colorMap = { textOrIconColor: '#fff', bgColor: '#000' };
    switch (type) {
      case 'menu':
        colorMap = { 
          textOrIconColor: this.class['menu__item--content']['color'], 
          bgColor: this.class['menu__item']['background-color'] 
        };
        break;
      case 'menu_con':
        colorMap = { 
          textOrIconColor: this.class['submenu__item--content']['color'], 
          bgColor: this.class['submenu__item']['background-color']
        };
        break;
      case 'khi_chon_menu':
        colorMap = { 
          textOrIconColor: this.config.desktop_background_active_menu_item.color, 
          bgColor: this.config.desktop_background_active_menu_item.background_color
        };
        break;
      case 'khi_chon_menu_con':
        colorMap = { 
          textOrIconColor: this.config.desktop_background_active_menu_item_sub.color, 
          bgColor: this.config.desktop_background_active_menu_item_sub.background_color
        };
        break;
    }
    const dialogRef = this.matDialog.open(ColorContrastComponent, {
      width: '30vw',
      height: 'fit-content',
      data: {
        /** Chứa map màu nền và màu chữ/icon */
        colorContrast: {
          typeFgColor: 'text',
          ...colorMap
        }
      },
    });

    dialogRef.afterClosed().subscribe((colorContrast) => {
      if (colorContrast) {
        switch (type) {
          case 'menu':
            this.class['menu__item--content']['color'] = colorContrast.textOrIconColor;
            this.class['menu__item']['background-color'] = colorContrast.bgColor;
            break;
          case 'menu_con':
            this.class['submenu__item--content']['color'] = colorContrast.textOrIconColor;
            this.class['submenu__item']['background-color'] = colorContrast.bgColor;
            break;
          case 'khi_chon_menu':
            this.config.desktop_background_active_menu_item.color = colorContrast.textOrIconColor;
            this.config.desktop_background_active_menu_item.background_color = colorContrast.bgColor;
            break;
          case 'khi_chon_menu_con':
            this.config.desktop_background_active_menu_item_sub.color = colorContrast.textOrIconColor;
            this.config.desktop_background_active_menu_item_sub.background_color = colorContrast.bgColor;
            break;
        }
        this.updateClass();
      }
    });
  }

  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   * - menu - 5
   * - menu_con - 6
   * - khi_chon_menu - 7
   * - khi_chon_menu_con - 8
   */
  addGradient(value, currentViewAllIndex) {
    const fieldTmp = this.fieldConfigGradient[currentViewAllIndex];
    if (/\#/.test(value)) {
      this.config[fieldTmp][`gradient_arr`] ??= [
        "rgb(0, 0, 255)",
        "rgb(255, 255, 0)"
      ];
      const gradient = this.config[fieldTmp];
      gradient[`gradient_arr`].push(
        `rgba(${this.hexToRGB(value)}, ${gradient.value_range})`
      );
      this.updateBackgroundRgb(currentViewAllIndex);
    }
  }

  /**
   * @param index : vị trí phần tử muốn xóa
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   * - menu - 5
   * - menu_con - 6
   * - khi_chon_menu - 7
   * - khi_chon_menu_con - 8
   */
  deleteGradient(index, currentViewAllIndex) {
    const fieldTmp = this.fieldConfigGradient[currentViewAllIndex];
    this.config[fieldTmp][`gradient_arr`] ??= [
      "rgb(0, 0, 255)",
      "rgb(255, 255, 0)"
    ];
    if (this.config[fieldTmp][`gradient_arr`].length > 1) {
      this.config[fieldTmp][`gradient_arr`].splice(index, 1);
      this.updateBackgroundRgb(currentViewAllIndex)
    }
  }

  /** 
   * Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   * - menu - 5
   * - menu_con - 6
   * - khi_chon_menu - 7
   * - khi_chon_menu_con - 8
   */
  chooseOption(direction, event, currentViewAllIndex) {
    if (isPlatformBrowser(this.platformId)) {
      const fieldTmp = this.fieldConfigGradient[currentViewAllIndex];
      // Gán các properties của phần tử direction vào biến trong json và cập nhật lưu vào database.
      this.config[fieldTmp].gradient_type = direction.type;
      this.config[fieldTmp].gradient_direction = direction.direction;

      this.config[fieldTmp][`gradient_arr`] ??= [
        "rgb(0, 0, 255)",
        "rgb(255, 255, 0)"
      ];
      const gradientStr = this.config[fieldTmp]?.gradient_type + '(' + this.config[fieldTmp]?.gradient_direction + this.config[fieldTmp]?.gradient_arr.join(',') + ')';

      switch (currentViewAllIndex) {
        case 5:
          this.class['menu__item']['background-image'] = gradientStr;
          break;
        case 6:
          this.class['submenu__item']['background-image'] = gradientStr;
          break;
        case 7:
          this.config.desktop_background_active_menu_item.background_image = gradientStr;
          break;
        case 8:
          this.config.desktop_background_active_menu_item_sub.background_image = gradientStr;
          break;
      }
      this.updateObject();
    }
  }

  /**
   * hàm cập nhật background linear-gradient
   * - menu - 5
   * - menu_con - 6
   * - khi_chon_menu - 7
   * - khi_chon_menu_con - 8
   */
  updateBackgroundRgb(currentViewAllIndex) {
    const fieldTmp = this.fieldConfigGradient[currentViewAllIndex];
    this.config[fieldTmp][`gradient_arr`] ??= [
      "rgb(0, 0, 255)",
      "rgb(255, 255, 0)"
    ];
    const gradientStr = this.config[fieldTmp]?.gradient_type + '(' + this.config[fieldTmp]?.gradient_direction + this.config[fieldTmp]?.gradient_arr.join(',') + ')';

    switch (currentViewAllIndex) {
      case 5:
        this.class['menu__item']['background-image'] = this.config[fieldTmp]?.gradient_check ? gradientStr : 'none';
        break;
      case 6:
        this.class['submenu__item']['background-image'] = this.config[fieldTmp]?.gradient_check ? gradientStr : 'none';
        break;
      case 7:
        this.config.desktop_background_active_menu_item.background_image = this.config[fieldTmp]?.gradient_check ? gradientStr : 'none';
        break;
      case 8:
        this.config.desktop_background_active_menu_item_sub.background_image = this.config[fieldTmp]?.gradient_check ? gradientStr : 'none';
        break;
    }
    this.updateObject();
  }
}
